<ng-container *ngIf="!loadingData">
  <div class="btn1" *ngIf="getObjectKeys(technicalDetailsDataMapByTechnicalDetailsId).length > 0 && isAssignedReviewer">
    <button class="newbtn" (click)="approveCodeReview()" [featureActionState]="'CODE_REVIEW'">Approve</button>
    <button class="newbtn" (click)="requestForChanges()" [featureActionState]="'CODE_REVIEW'">Request for Changes</button>
  </div>
  <div class="layout_option" *ngIf="getObjectKeys(technicalDetailsDataMapByTechnicalDetailsId).length > 0">
    <!-- <button (click)="toggleViewMode()">
      Toggle to {{ viewMode === 'side-by-side' ? 'Line-by-Line' : 'Side-by-Side' }} View
    </button> -->
    <div class="setting_btn" (click)="showdiffView()">
      <span class="material-symbols-rounded">
        settings
      </span>
      <span class="material-symbols-rounded">
        arrow_drop_down
      </span>
    </div>
  </div>
  <div class="diffView" *ngIf=showDiffView>
    <!-- <div class="diffview_top">
      Diff view
    </div> -->
    <div class="diffview_middle">
      <div class="sidebyside" *ngIf="!isVisible" (click)="toggleView()">
        <img src="../../../../assets/images/spiltview.svg">
        <div class="sidebyside_bot">
          <!-- <input type="radio" name="viewMode" [(ngModel)]="viewMode" 
          value="sidebyside"  (click)="toggleViewMode()"> -->
          Split
        </div>
      </div>
      <div class="linebyline" *ngIf="isVisible" (click)="toggleView()">
        <img src="../../../../assets/images/linebyline.svg">
        <div class="linebyline_bot">
          <!-- <input type="radio"  name="viewMode2" 
          [(ngModel)]="viewMode" 
          value="linebyline"  (click)="toggleViewMode()"> -->
          Unified
        </div>
      </div>
    </div>
    <!-- <div class="diffview_bot">
      <button>Apply and reload</button>
    </div> -->

  </div>
  <ul>
    <li *ngFor="let technicalDetailsId of getObjectKeys(technicalDetailsDataMapByTechnicalDetailsId)">
      <div class="linkage-mapping-header">
        <div class="code-changed-header">
          <mat-icon class="chevron-icon" (click)="toggleMapping(technicalDetailsId)">
            {{ !isExpanded(technicalDetailsId) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
          <strong>
            <ng-container *ngIf="technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].source != 'github'">
              <span
                *ngIf="getFirstData(technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].data) as firstData">
                {{ firstData.key }}: {{ firstData.value }}
              </span>
            </ng-container>
            <span *ngIf="technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].source == 'github'">
              {{ technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].data['file name'] }}
            </span>
          </strong>
        </div>
        <div style="display: flex;">
          <mat-icon class="btn-icon" (click)="onAddComment(technicalDetailsId)"
            [disabled]="commentsModification[technicalDetailsId].isAddingComment" [featureActionState]="'CODE_REVIEW'">chat_bubble_outline</mat-icon>
          <button class="btn-icon" (click)="addAiFeedback(technicalDetailsId)"
            [disabled]="technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].source != 'github'" [featureActionState]="'CODE_REVIEW'">Ai</button>
        </div>
      </div>

      <!-- Expandable table for technical details -->
      <ng-container *ngIf="!isExpanded(technicalDetailsId)">
        <ng-container *ngIf="technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].source == 'github'">
          <ze-code-diff-viewer
            [patch]="technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].data['code diff']"
            [viewMode]="viewMode"></ze-code-diff-viewer>
        </ng-container>

        <ng-container
          *ngIf="technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].source != 'github' && technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].data">
          <table>
            <thead>
              <tr>
                <th
                  *ngFor="let key of getObjectKeys(technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].data)">
                  {{ key | titlecase }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  *ngFor="let value of getObjectValues(technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].data)">
                  {{ value }}
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>

        <ng-container
          *ngIf="reviewCommentsMapByTechnicalDetailsId[technicalDetailsId]?.length > 0 && !commentsModification[technicalDetailsId].isUpdatingDeleted">
          <div *ngFor="let comment of reviewCommentsMapByTechnicalDetailsId[technicalDetailsId]; let i = index">
            <ng-container *ngIf="!comment.outdated && comment.parent_comment_id == null">
              <ng-container
                *ngTemplateOutlet="reviewCommentTemplate; context: { comment: comment, pos: i, technicalDetailsId: technicalDetailsId }"></ng-container>
            </ng-container>
          </div>
        </ng-container>

      </ng-container>

      <div class="mybtn1" *ngIf="commentsModification[technicalDetailsId].isAddingComment">
        <textarea [(ngModel)]="commentsModification[technicalDetailsId].addText"
          placeholder="Type your comment here..."></textarea>
        <div class="comment_btn">
          <button class="newbtn" (click)="onCommentSubmit(technicalDetailsId)"
            [disabled]="commentsModification[technicalDetailsId].addText == ''" [featureActionState]="'CODE_REVIEW'">Submit</button>
          <button class="newbtn" (click)="onCommentCancel(technicalDetailsId)">Cancel</button>
        </div>

      </div>
      <p *ngIf="!technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].data">No technical details available
        for this mapping.</p>
    </li>
  </ul>
</ng-container>

<ng-template #reviewCommentTemplate let-comment="comment" let-i="pos" let-technicalDetailsId="technicalDetailsId">
  <div class="review-comment-container">
    <div class="comment-container">
      <div class="review-comment-header">
        <span class="review-comment-header-left"><strong>{{ comment.created_by }}</strong> on {{comment.created_time |
          date:'MMM d, yyyy, h:mm:ss a'}}</span>
        <mat-icon [matMenuTriggerFor]="reviewCommentMenu" class="btn-icon" [featureActionState]="'CODE_REVIEW'">more_horiz</mat-icon>
      </div>
      <mat-menu #reviewCommentMenu="matMenu">
        <button mat-menu-item (click)="onReviewCommentEdit(technicalDetailsId, i)"
          [disabled]="commentsModification[technicalDetailsId].comments[i].isEditing">
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>
        <button mat-menu-item (click)="onReviewCommentDelete(technicalDetailsId, i)">
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>

      <div class="comment-body" *ngIf="!commentsModification[technicalDetailsId].comments[i].isEditing">
        <div class="my" *ngFor="let section of getSections(comment.body)">
          <div [ngClass]="{
              'severity-info': section.heading === 'Severity' && section.content.toLowerCase() === 'info',
              'severity-critical': section.heading === 'Severity' && section.content.toLowerCase() === 'critical',
              'severity-high': section.heading === 'Severity' && section.content.toLowerCase() === 'high',
              'severity-medium': section.heading === 'Severity' && section.content.toLowerCase() === 'medium',
              'severity-low': section.heading === 'Severity' && section.content.toLowerCase() === 'low',
              'section-Issue-Description': section.heading === 'Issue Description',
              'section-Impact': section.heading === 'Impact',
              'section-Recommendations': section.heading === 'Recommendations'     
            }" class="section-container">
            <span [ngClass]="getHeadingClass(section.heading)">
              {{ section.heading }}
            </span>
            <ng-container *ngIf="section.content">
              <div *ngFor="let item of getListItems(section.content); let i = index">
                <span [ngClass]="getTextClass(item)">
                  {{ i + 1 }}. {{ item }}
                </span>
              </div>
            </ng-container>
            <ng-container *ngIf="!isBulletList(section.content) && !isNumberedList(section.content) && getListItems(section.content).length === 0">
              <span [ngClass]="getTextClass(section.content)">
                {{ section.content }}
              </span>
            </ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="commentsModification[technicalDetailsId].comments[i].isEditing">
        <textarea [(ngModel)]="commentsModification[technicalDetailsId].comments[i].editText"
          placeholder="Type your comment here..."></textarea>
        <button (click)="onReviewCommentEditSubmit(technicalDetailsId, i)"
          [disabled]="commentsModification[technicalDetailsId].comments[i].editText == '' || commentsModification[technicalDetailsId].comments[i].editText == comment.body" [featureActionState]="'CODE_REVIEW'">Update
          Comment</button>
        <button (click)="onReviewCommentEditCancel(technicalDetailsId, i)">Cancel</button>
      </div>

      <div *ngIf="comment.replies.length > 0" class="replies">
        <ng-container *ngFor="let replyId of comment.replies; let replyIndex = index">
          <ng-container *ngIf="getReply(technicalDetailsId, replyId) as reply">
            <div class="reply-header">
              <span class="reply-comment-header-left"><strong>{{ reply.created_by }}</strong> on {{reply.created_time |
                date:'MMM d, yyyy, h:mm:ss a'}}</span>
              <mat-icon [matMenuTriggerFor]="reviewCommentReplyMenu" class="btn-icon" [featureActionState]="'CODE_REVIEW'">more_horiz</mat-icon>
            </div>
            <mat-menu #reviewCommentReplyMenu="matMenu">
              <button mat-menu-item (click)="onReplyEdit(technicalDetailsId, i, replyIndex)"
                [disabled]="commentsModification[technicalDetailsId].comments[i].replies[replyIndex].isEditing">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button mat-menu-item (click)="onCommentReplyDelete(technicalDetailsId, i, replyIndex)">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
            <div class="comment-body"
              *ngIf="!commentsModification[technicalDetailsId].comments[i].replies[replyIndex].isEditing">
              <p>{{ reply.body }}</p>
            </div>
            <div *ngIf="commentsModification[technicalDetailsId].comments[i].replies[replyIndex].isEditing">
              <textarea [(ngModel)]="commentsModification[technicalDetailsId].comments[i].replies[replyIndex].editText"
                placeholder="Type your comment here..."></textarea>
              <button (click)="onReplyEditSubmit(technicalDetailsId, i, replyIndex)"
                [disabled]="commentsModification[technicalDetailsId].comments[i].replies[replyIndex].editText == '' || commentsModification[technicalDetailsId].comments[i].replies[replyIndex].editText == reply.body" [featureActionState]="'CODE_REVIEW'">Update
                Comment</button>
              <button (click)="onReplyEditCancel(technicalDetailsId, i, replyIndex)">Cancel</button>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div *ngIf="!commentsModification[technicalDetailsId].comments[i].isReplying">
        <button class="mybtn newbtn" (click)="onReply(technicalDetailsId, i)" [featureActionState]="'CODE_REVIEW'">Reply</button>
      </div>

      <div class="mybtn1" *ngIf="commentsModification[technicalDetailsId].comments[i].isReplying">
        <textarea [(ngModel)]="commentsModification[technicalDetailsId].comments[i].replyText"
          placeholder="Type your reply here..."></textarea>

        <div class="comment_btn">
          <button class="newbtn" (click)="onReplySubmit(technicalDetailsId, i)"
            [disabled]="commentsModification[technicalDetailsId].comments[i].replyText == ''" [featureActionState]="'CODE_REVIEW'">Submit</button>
          <button class="newbtn" (click)="onReplyCancel(technicalDetailsId, i)">Cancel</button>
        </div>

      </div>

      <div class="resolution-container">
        <button class="newbtn" *ngIf="comment.resolved"
          (click)="updateConversationResolution(technicalDetailsId, i, false)" [featureActionState]="'CODE_REVIEW'">Unresolve Conversation</button>
        <button class="newbtn" *ngIf="!comment.resolved"
          (click)="updateConversationResolution(technicalDetailsId, i, true)" [featureActionState]="'CODE_REVIEW'">Resolve Conversation</button>
        <span *ngIf="comment.resolved">{{comment.resolved_by}} marked this conversation as resolved</span>
      </div>
    </div>
  </div>
</ng-template>